import styled from 'styled-components';
import { getSizeBy } from '../../../src/styled/utils';
import { Body2Styles } from '../typography';
import { List } from '../list';
import { ListItem } from '../list-item';
export const StyledModalBody = styled.div `
  width: ${getSizeBy(96)};
  max-width: 100%;
  padding: ${getSizeBy(6)};
`;
export const ModalList = styled(List) `
  margin: ${getSizeBy(2)} 0;
  ${Body2Styles}
`;
export const ModalListItem = styled(ListItem) `
  & > div {
    padding-left: 0;
  }
`;
export const Email = styled.a `
  text-decoration: none;
`;
